/**
 * Created by yz on 2017/3/24.
 * 备注：utils.constant这个工厂模式没有注入别的服务，也没有用到angular.js自带的服务，所以可以这样写。
 */
 {
angular.module("utilsModule")
    .factory("utils.constant", function(){
        // TODO: 接口路径改为固定，正式版时需要关闭
        //const defaultPath='http://www.my51y.com/xyprint_web/interfaces';
        //const defaultPath='xyprint_web/interfaces';
        const defaultPath='interfaces';
        return {

            action: {

                'login':defaultPath+'/userlogin.php',
                'logout':defaultPath+'/userlogout.php',

                'getUserId':defaultPath+'/getuserlogininfo_with_area.php',
                'getUserInfoById':defaultPath+'/userinfoget.php',     //获取用户信息
                'registerNew':defaultPath+'/usersnew.php',
                'forget':defaultPath+'/usersset.php',
                'usersset':defaultPath+'/usersset.php',
                'userinfoget':defaultPath+'/userinfoget.php',
                'getVerify_code':defaultPath+'/sms_class.php',
                'userquery':defaultPath+'/userquery.php',

                'upload':defaultPath+'/../common/swfupload/upload.php',
                'uploadResult':defaultPath+'/uploaddocget.php',//获取当前用户最后上传的文档的信息
                'printSizeSelection':defaultPath+'/pagesizelist.php',

                'createOrder':defaultPath+'/ordersnew.php',
                'createPaperOrder':defaultPath+'/ordersnewlw.php',//创建论文订单
                
                //'setOrderPaid':defaultPath+'/custompay.php',//将订单设为已支付
                'setOrderPaid':defaultPath+'/custompay_new.php',//将订单设为已支付
                //'setOrderPaid':defaultPath+'/custompay_2.php',//将订单设为已支付
                'printQrcode':defaultPath+'/getqrcode.php',//获取打印二维码
                'cancelOrder':defaultPath+'/orderprintcancel.php',
                'modifyOrder':defaultPath+'/ordersset.php',
                'orderpayquery':defaultPath+'/orderpayquery.php',//点击支付时改变支付状态 检查是否有已支付而订单状态为待支付

                'orderRefundApply':defaultPath+'/refundnew.php',
                'orderRefundDetail':defaultPath+'/refundquery.php',
                'refundUpload':'/xyprint_web/common/swfupload/upload_refund.php',
                'upload_imageprint':'/xyprint_web/common/swfupload/upload_imageprint.php',//上传打印图片
                'uploadimageinfoget':defaultPath+'/uploadimageinfoget.php',//去合成图片

                //这三个都是获取订单（列表或详情）信息的接口，获取的信息合起来才完整
                'orderList':defaultPath+'/orderslist.php',
                //'orderSearch':defaultPath+'/ordersquery.php',
                'orderSearch':defaultPath+'/ordersquery_with_area.php',
                'orderList_print':defaultPath+'/orderprintlist_with_area.php',

                'ordersnew_printagain':defaultPath+'/ordersnew_printagain.php',
                'ordersquery_printagain':defaultPath+'/ordersquery_printagain.php',
                'paydiscountquery':defaultPath+"/paydiscountquery.php",//获取所有支付方式的折扣信息

                'balancePay':defaultPath+'/balancepayment.php', //余额支付
                //'balancetransaction':defaultPath+'/balancetransaction.php',   //账户充值、余额支付、余额退款
                //'balancetransaction':defaultPath+'/balancetransaction_1.php',   //账户充值、余额支付、余额退款
                'balancetransaction':defaultPath+'/balancetransaction_new.php',   //账户充值、余额支付、余额退款
                'rechargegiftoperation':defaultPath+'/rechargegiftoperation.php', //获取充值赠送比例。
                'rechargeconfig': defaultPath+'/rechargeconfig.php',        //获取可充值金额及赠送金额
                'paydiscountoperation':defaultPath+'/paydiscountoperation.php',//查询余额支付折扣
                //cl 新增
                //'balancetransactioncheck':defaultPath+'/balancetransactioncheck.php',//余额刷新
                'balancetransactioncheck':defaultPath+'/balancetransactioncheck_new.php',//余额刷新
                'balancetransaction_insert':defaultPath+'/balancetransactionlog_insert.php',//点击充值按钮时 添加信息入表
                'checkRechargeTransid' : defaultPath+'/checkRechargeTransid.php',//用户输入充值单号充值。
                'getRechargeRecord': defaultPath+'/getRechargeRecord.php',//用户输入充值单号充值。

                'companyinfoquery': defaultPath+'/companyinfoquery.php',     //用userid获取公司信息
                'companyuserpayment':defaultPath+'/companyuserpayment.php',   //订单月结
                'usermanagerorderquery' : defaultPath+'/usermanagerorderquery.php',  //企业管理用户订单查询操作接口
                'usermanageroperation' : defaultPath+'/usermanageroperation.php',    //企业管理用户员工操作的PHP接口
                'companyuserregister':defaultPath+'/companyuserregister.php',     //申请企业用户
                'companyregister':defaultPath+'/companyregister.php',    //添加员工
                'deptoperation': defaultPath+'/deptoperation.php',     //添加部门 查询企业所有部门信息,修改部门信息
                'companyCurMonCount' : defaultPath+'/companycurmoncount.php', //当前月统计
                'staffPrintOrders' : defaultPath+'/staffPrintOrders.php',  //员工打印订单查询
                'staffRefundOrders' : defaultPath+'/staffRefundOrders.php',  //员工打印订单查询
                'companyDayCount' : defaultPath+'/companyDayCount.php',  //日统计

                'partneroperation': defaultPath+'/partneroperation.php',   //加盟商管理接口
                'partnermachineoperation': defaultPath+'/partnermachineoperation.php',     //加盟商关联终端机的管理
                'partnerprintcount': defaultPath+'/partnerprintcount.php',       //加盟商历史月统计
                'partnermachineinfo': defaultPath+'/partnermachineinfo.php',     //加盟商终端机信息查询
                'partnercurrinfo': defaultPath+'/partnercurrinfo.php',          //加盟商当前月统计
                'partnerordersquery':defaultPath+'/partnerordersfind.php',   //加盟商订单查询
                'partnerdayinfo':defaultPath+'/partnerdayinfo.php',         //查询指定日期加盟商营业统计

                // 2019-7-11 ryj 添加wo支付接口
                'appPay_wo': "/xyprint_web/wopay/china_unicom_pay.php", //wo支付提交地址
                'appPay_wo_recharge': "/xyprint_web/wopay/china_unicom_pay_recharge.php", //wo支付recharge

                // 2021-6-10 ryj 添加boc支付相关接口
                'appPay_boc_amoundQuery': "/xyprint_web/bocpay/getorderbocpayamount.php", //boc支付查询支付金额接口
                'appPay_boc_amoundQuery_new': "/xyprint_web/bocpay/getorderbocpayamount_new.php", //boc支付查询支付金额接口
                'appPay_boc': "/xyprint_web/bocpay/bocpay.php", //boc支付提交地址
                'appPay_boc_new': "/xyprint_web/bocpay/bocpay_new.php", //boc支付提交地址

                'qrpay_ali':"/xyprint_web/alipay/f2fpay/qrpay_test1.php",//获取支付宝支付二维码
                'appPay_ali':"/xyprint_web/alipay_wap/wappay/pay.php",//支付宝手机支付提交地址
                //'checkPayResult_ali':"/xyprint_web/alipay/f2fpay/query_test.php",//检测是否完成支付
                'checkPayResult_ali':"/xyprint_web/alipay/f2fpay/query_test1.php",//检测是否完成支付
                // 'checkAppPayResult_ali':"/xyprint_web/alipay_wap/wappay/query.php",//检测手机是否完成支付

                'qrpay_wechat':"/xyprint_web/wxpay/example/native_new.php",//获取微信支付二维码
                //'qrpay_wechat':"http://59.110.26.225/xyprint_web/wxpay/example/native_new.php",//获取微信支付二维码
                //'qrpay_wechat':"/xyprint_web/wxpay/example/native.php",//获取微信支付二维码
                //'checkPayResult_wechat':"http://59.110.26.225/xyprint_web/wxpay/example/orderquery.php",//检测是否完成支付
                'checkPayResult_wechat':"/xyprint_web/wxpay/example/orderquery.php",//检测是否完成支付
                'appPay_wechat':"/xyprint_web/wxpay/example/jsapi_new.php",//微信内调用支付
                //'appPay_wechat':"http://www.my51y.com/xyprint_web/wxpay/example/jsapi_new.php",//微信内调用支付
                //'appPay_wechat':"/xyprint_web/wxpay/example/jsapi_new.php",//微信内调用支付
                'appPay_wechat_test': "/xyprint_web/wxpay/example/jsapi_test.php",//微信充值内调用支付测试

                //'wechatOpenId':'/xyprint_web1/interfaces/wx_get_openid.php',//地址跳转获取openid
                //'wechatOpenId':'/xyprint_web/wxpay/example/wx_get_openid_new.php',
                'wechatOpenId':'http://www.my51y.com/xyprint_web/wxpay/example/wx_get_openid_new.php',
                'wechatOpenIdViaCode':'/xyprint_web/interfaces/wx_openid.php',//通过code获取openid
                //'wechatOpenIdViaCode':'http://www.my51y.com/xyprint_web/interfaces/wx_openid.php',//通过code获取openid
                'wechatLogin':defaultPath+'/userlogin_wx.php',//登录同时绑定openid及通过openid登录
                'wechatLogout':defaultPath+'/userlogout_wx.php',//退出登录同时解除openid绑定
                //'wechatLogin':'http://test.my51y.com'+defaultPath+'/userlogin_wx.php',//登录同时绑定openid及通过openid登录
                //'wechatLogout':'http://test.my51y.com'+defaultPath+'/userlogout_wx.php',//退出登录同时解除openid绑定

                'announcement':defaultPath+'/announcement.php',//公告接口
                'videoOperate':defaultPath+'/videoOperate.php',//视频接口
                'machinestatus':defaultPath+'/machinestatus.php',//终端机打印量和耗材等数据
                'supplystatusget':defaultPath+'/supplystatusget.php',//获取指定终端机耗材报表页接口

                'debuglog':defaultPath+'/debuglog.php',//测试log

                // 测试使用
                //'arealist':'http://www.my51y.com/xyprint/interfaces/arealist.php?fapps=1',
                //'setarealist':'http://www.my51y.com/xyprint_web/interfaces/userupdate_areaid_mp.php',

                'arealist':defaultPath+'/arealist.php?fapps=1',
                'setarealist':defaultPath+'/userupdate_areaid_mp.php',

            },
            config: {
                'sitePath': '',//本地代理服务器地址
                'sitePDF': '', //本地代理服务器地址
                //'sitePDF': 'http://47.107.163.128', //本地代理服务器地址
                'siteIMG': '', //本地代理服务器地址

                //'fileServerPath': 'http://39.106.57.8',
                //'fileServerPath': "http://47.107.163.128",
                //'fileServerPath': "http://120.77.149.154",

                'previewPath': '/xyprint_web/modules/images_preview',
                'pdf_previewPath':'/xyprint_web/modules/pdf_upload',

                //'previewPath':'http://39.106.57.8/xyprint_web/modules/pdf_upload',
                //'previewPath':'http://47.107.163.128/xyprint_web/modules/pdf_upload',
                //'previewPath':'http://47.107.163.128/xyprint_web/modules/pdf_upload',

                'refundImagePath':'/xyprint_web/modules/img_upload/',
                'imgPrintPath':'/xyprint_web/modules/imgprint_upload/'
            }
        }
    });
}